<template>
    <div class="dd-m-auth dd-m-auth--login">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Hello! Sign in or<br/>create an account—</h2>

            <div class="dd-m-auth__form">
                <form class="dd-m-form dd-m-form--login dd-m-form--auth"
                      novalidate v-on:submit.prevent="sign()">
                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.email && !fields.email.valid && fields.email.touched,
                             'is-validated' : fields.email && fields.email.valid && fields.email.touched}">

                            <input name="email"
                                   type="email"
                                   required
                                   v-on:focus="user.email.errors = []"
                                   v-validate="'required|email'"
                                   v-model="user.email.value"
                                   placeholder="E-mail"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.email.errors.length">
                                {{user.email.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.password && !fields.password.valid && fields.password.touched,
                             'is-validated' : fields.password && fields.password.valid && fields.password.touched}">
                            <input name="password"
                                   type="password"
                                   required placeholder="Senha"
                                   v-model="user.password.value"
                                   v-validate="'required'"
                                   v-on:focus="user.password.errors = []"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.password.errors.length">
                                {{user.password.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-alert dd-m-alert--danger" v-if="errors.length">
                        <span v-for="(item, index) in errors" :key="index">
                            {{item}}
                        </span>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col">
                            <vue-ladda
                                button-class="dd-m-form__submit dd-m-button dd-m-button--default dd-m-button--assertive"
                                :loading="loading">
                                Entrar
                            </vue-ladda>
                        </div>
                    </div>

                    <div class="dd-m-form--auth__actions">
                        <button v-on:click="openRecoveryModal()" type="button"
                                class="dd-m-form--auth__btn dd-m-form--auth__recovery-btn">
                            Esqueceu sua senha?
                        </button>
                    </div>
                </form>

                <div class="dd-m-form--auth__options">
                    <facebook-sign></facebook-sign>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import AuthService from '../../providers/api/auth-service';
    import FacebookSign from "../facebook-sign";

    const api = new AuthService();

    export default {
        name: 'auth-login',
        components: {FacebookSign},
        data: () => {
            return {
                loading: false,
                errors: [],
                user: {
                    email: {
                        value: null,
                        errors: []
                    },
                    password: {
                        value: null,
                        errors: []
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            openRecoveryModal: () => {
                PubSub.publish('closeLoginModal');
                PubSub.publish('openRecoveryModal', 1);
            },
            openRegisterModal: () => {
                PubSub.publish('closeLoginModal');
                PubSub.publish('openRegisterModal');
            },
            reset() {
                this.user.email.errors = [];
                this.user.password.errors = [];
                this.errors = [];
            },
            sign() {
                this.reset();

                if (this.user.email.value && this.user.password.value) {

                    this.loading = true;
                    const data = {
                        "email": this.user.email.value,
                        "password": this.user.password.value
                    };

                    api.doSign(data)
                        .then((res) => {
                            localStorage.token = res.data.data.token;
                            this.loading = false;

                            PubSub.publish('updatedSign');
                            PubSub.publish('closeLoginModal', true);
                        })
                        .catch((err) => {

                            if (err.response && err.response.status === 401) {
                                this.errors = [err.response.data.error.message];

                                // Update fields' icons
                                this.fields.email.valid = false;
                                this.fields.password.valid = false;
                            }

                            if (err.response && err.response.status === 422) {
                                const errValidations = err.response.data.error.validations;
                                for (const j in errValidations) {
                                    if (errValidations.hasOwnProperty(j) && this.user[j]) {
                                        this.user[j].errors = errValidations[j];
                                    }
                                }
                            }

                            this.loading = false;
                        });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-login.vue